import { render, staticRenderFns } from "./GraphDetail85.vue?vue&type=template&id=0b4c1af2&scoped=true"
import script from "./GraphDetail85.vue?vue&type=script&lang=js"
export * from "./GraphDetail85.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c1af2",
  null
  
)

export default component.exports